<template>
    <div>
        <div>
            <FullCalendar :plugins="calendarPlugins" :all-day-slot="false" :header="{ // 头部样式
                left:   'prev',
                center: 'title',
                right:  'today next'
            }" :button-text="{ //头部按钮样式
                today: '今天'
            }" :event-overlap="false" :events="event" columnHeaderFormat="ddd" :select-overlap="false"
                :first-day="nowDay" :business-hours="businessHours" :select-allow="handlerAllow" :select-mirror="true"
                selectable="true" min-time="00:00:00" max-time="24:00:00" slot-duration="01:00:00"
                slot-label-format="HH:mm" default-view="timeGridWeek" locale="zh-cn" @eventClick="handleEventClick"
                @eventDrop="handDrop" :eventConstraint="businessHours" @select="handleSelect" :height="596"
                :editable="true" :eventDurationEditable="false" :resourceIds="businessHours"
                :selectConstraint="businessHours" :valid-range="visibleRange" />
        </div>
    </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import momentPlugin from '@fullcalendar/moment'
import '@fullcalendar/core/locales/zh-cn'
import timeGridPlulgin from '@fullcalendar/timegrid'


export default {
    components: {
        FullCalendar
    },
    props: {
        event: {
            type: Array,
            default: () => []
        },
        data: {
            type: Array,
            default: () => []
        },
        day: {
            type: Number
        }
    },
    data () {
        return {
            calendarPlugins: [dayGridPlugin, timeGridPlulgin, momentPlugin, interactionPlugin],
            arr: [],
            businessHours: []
        }
    },
    computed: {
        nowDay () { //使得日历是当前时间的后七天
            return new Date().getDay()
        },
        visibleRange () {
            let nowDate = new Date()
            return {
                start: nowDate,
                end: this.getDateStr(this.day)
            }
        },
    },
    created () {
        this.init()
    },
    methods: {
        formatTime (t) {
            let a = new Date(t).toJSON()
            let b = new Date(+new Date(a) + 8 * 3600 * 1000)
            let c = b.toISOString()
            let d = c.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
            return d
        },
        transform (val, k) {
            if (typeof (val) == 'string') {
                let a = val.split(",")
                let b = {
                    startTime: `${a[0]}:00`,
                    endTime: `${a[1]}:00`,
                    daysOfWeek: [k]
                }
                this.arr.push(b)
            } else if (typeof (val) == 'number') {
                let c = {
                    startTime: `${val}:00`,
                    endTime: `${val + 1}:00`,
                    daysOfWeek: [k]
                }
                this.arr.push(c)
            }
            this.businessHours = this.arr
        },
        getDateStr (t) {
            var dd = new Date();
            dd.setDate(dd.getDate() + t);
            var y = dd.getFullYear();
            var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);//获取当前月份的日期，不足10补0
            var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();//获取当前几号，不足10补0
            return y + "-" + m + "-" + d;
        },
        init () {
            this.data.map((item, index) => {
                item.map(j => {
                    this.transform(j, index)
                })
            })
        },
        handlerAllow: info => {
            let a = info.start.getHours()
            let b = info.end.getHours()
            let c = info.start.getDay()
            let d = info.end.getDay()
            const currentDate = new Date()
            const start = info.start
            const end = info.end
            return (start <= end && start >= currentDate && b - a == 1 && c == d)
        },
        handleSelect (info) {
            this.$emit("add", info)
        },
        handleEventClick (val) {
            this.$emit("eventClick", val)
        },
        handDrop (val) {
            this.$emit("drop", val)
        }
    }
}

</script>

<style lang="scss">
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
.fc-nonbusiness,
.fc-button-primary:disabled {
    cursor: no-drop;
}
</style>